import type { PermissionGroup } from '../../../../api/rbac-client/rbac-client.type';
import { PanelList } from '../panel-list';
import { ALL_GROUPS_ID, toSidebarItems } from './groups-tab.helpers';

export function GroupsList({
  groups,
  selectedGroupId,
  onSelectGroup,
}: {
  groups: PermissionGroup[];
  selectedGroupId: string | null;
  onSelectGroup: (groupId: string | null) => void;
}) {
  const items = toSidebarItems(groups);
  const effectiveSelectedId = selectedGroupId ?? ALL_GROUPS_ID;

  return (
    <PanelList
      title="Groups"
      items={items}
      selectedItem={items.find((item) => item.id === effectiveSelectedId) ?? null}
      onSelect={(item) => {
        onSelectGroup(item.id === ALL_GROUPS_ID ? null : item.id);
      }}
      getItemId={(item) => item.id}
      getItemDisplayText={(item) => item.name}
    />
  );
}
